import { render, staticRenderFns } from "./productModelManagement.vue?vue&type=template&id=6705d698&scoped=true&"
import script from "./productModelManagement.vue?vue&type=script&lang=js&"
export * from "./productModelManagement.vue?vue&type=script&lang=js&"
import style0 from "./productModelManagement.vue?vue&type=style&index=0&id=6705d698&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705d698",
  null
  
)

export default component.exports